import { useMemo } from "react";
import clsx from "clsx";

import classes from "../../styles.module.scss";

import { Pagination } from "@components/molecules/pagination";
import type { ITableBottomProps } from "@components/organisms/pageTable";
import { TablePageNumber } from "@components/organisms/pageTable/components/tablePageNumber";
import { TablePerPageSelector } from "@components/organisms/pageTable/components/tablePerPageSelector";
import { useMaxMedia } from "@utils";
import { IBreakpoint } from "@constants";

export function TableBottom({ pagination, total = 0 }: ITableBottomProps) {
  const page = pagination?.page || 1;
  const perPage = pagination?.per_page || 10;

  const totalPages = useMemo(
    () => calculateTotalPages(total, perPage),
    [perPage, total],
  );

  const media = useMaxMedia(IBreakpoint.SM);

  return (
    pagination &&
    (media ? (
      <div className={clsx(classes.pageTable__tableBottomMedia)}>
        <Pagination
          totalPages={totalPages}
          currentPage={page}
          perPage={perPage}
          onPageChange={(page) => {
            pagination?.onPageChange?.(page);
          }}
          onPerPageChange={(perPage) => {
            pagination?.onResultPerPageChange?.(perPage);
          }}
        />
        <div className={clsx(classes.pageTable__paginationSelector)}>
          <TablePerPageSelector
            perPage={perPage}
            onResultPerPageChange={pagination?.onResultPerPageChange}
          />
          <TablePageNumber page={page} perPage={perPage} total={total} />
        </div>
      </div>
    ) : (
      <div className={clsx(classes.pageTable__tableBottom)}>
        <TablePerPageSelector
          perPage={perPage}
          onResultPerPageChange={pagination?.onResultPerPageChange}
        />
        <Pagination
          totalPages={totalPages}
          currentPage={page}
          perPage={perPage}
          onPageChange={(page) => {
            pagination?.onPageChange?.(page);
          }}
          onPerPageChange={(perPage) => {
            pagination?.onResultPerPageChange?.(perPage);
          }}
        />
        <TablePageNumber page={page} perPage={perPage} total={total} />
      </div>
    ))
  );
}

function calculateTotalPages(
  totalDataCount: number,
  itemsPerPage: number,
): number {
  if (totalDataCount <= 0 || itemsPerPage <= 0) {
    // Return 0 pages for invalid input.
    return 0;
  }

  return Math.ceil(totalDataCount / itemsPerPage);
}
